<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
          ref="form"
          :get-data="getData"
          :submit="onSubmit"
          :form.sync="form"
          :errors.sync="errors"
          :edit-mode="editMode"
      >
          <el-form-item label="车牌号" required prop="bike_no">
              <el-input :disabled="this.resourceId" v-model="form.bike_no"/>
          </el-form-item>

          <el-form-item label="控制设备编号" prop="box_no">
              <el-input v-model="form.box_no"/>
          </el-form-item>

          <el-form-item label="投放区域" prop="put_area_id">
              <el-select
                  v-model="form.put_area_id"
                  clearable
                  placeholder="选择区域"
              >
                  <el-option
                      v-for="i in areas"
                      :key="i.id"
                      :label="i.name"
                      :value="i.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放状态" required prop="put_status">
          <el-radio v-model="form.put_status" label="0">未投放</el-radio>
          <el-radio v-model="form.put_status" label="1">已投放</el-radio>
        </el-form-item>
          <el-form-item label="投放时间" prop="put_time">
              <el-date-picker
                  v-model="form.put_time"
                  type="datetime"
                  placeholder="选择日期时间"
              />
          </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { editBike, storeBike, updateBike } from '@/api/bike'
import { getAreas } from '@/api/area'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        'bike_no': '',
        'box_no': '',
        'put_area_id': '',
        'put_status': '',
        'put_time': '',
      },
      errors: {},
      areas: [],
    }
  },
  methods: {
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = areas

      if (this.editMode) {
        const { data } = await editBike(this.resourceId)
        data.put_status = data.put_status ? '1' : '0'
        this.fillForm(data)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateBike(this.resourceId, this.form)
      } else {
        await storeBike(this.form)
      }
    },
  },
}
</script>
